import { Check } from "lucide-react";

export default function SingleOption({
  label,
  sub,
  emoji,
  selected,
  onClick,
  highlight,
}: {
  label: string;
  sub?: string;
  emoji?: string;
  selected: boolean;
  onClick: () => void;
  highlight?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-2xl border-2 text-left transition-all duration-150 cursor-pointer ${
        selected
          ? "border-violet-500 bg-violet-50 shadow-sm shadow-violet-100"
          : highlight
            ? "border-dashed border-violet-200 bg-violet-50/30 hover:border-violet-300"
            : "border-slate-200 bg-white hover:border-violet-300 hover:bg-violet-50/30"
      }`}
    >
      {emoji && <span className="text-[20px] flex-shrink-0">{emoji}</span>}
      <div className="flex-1 min-w-0">
        <span
          className={`text-[13px] block ${selected ? "text-violet-700" : "text-slate-800"}`}
          style={{ fontWeight: selected ? 600 : 500 }}
        >
          {label}
        </span>
        {sub && (
          <span
            className="text-[11px] text-slate-400"
            style={{ fontWeight: 400 }}
          >
            {sub}
          </span>
        )}
      </div>
      {selected && (
        <div className="w-5 h-5 rounded-full bg-violet-600 flex items-center justify-center flex-shrink-0">
          <Check className="w-3 h-3 text-white" />
        </div>
      )}
    </button>
  );
}
